module.exports = __webpack_public_path__ + "f38f7b56e4565ecf19e121f3aefadec3.webp";